import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/TopBar";
import OverviewStatsSection from "../../components/OverviewStatsSection";
import AppointmentsTrendChart from "../../components/AppointmentsTrendChart";
import RiskDistributionChart from "../../components/RiskDistributionChart";
import TopPractitionersSection from "../../components/TopPractitionersSection";
import AvailablePractitionersSection from "../../components/AvailablePractitionersSection";
import RecentBookedTable from "../../components/RecentBookedTable";
import EventParticipationTable from "../../components/EventParticipationTable";
import { getSummary } from "../../api/Dashboard/SummarySlice";
import { topPractitioner } from "../../api/Dashboard/TopPractitionerSlice";
import { getCounsellorList } from "../../api/Data/Counsellor/index";
import { getWellness } from "../../api/Wellness/WellnessSlice";
import { useDashboardData } from "../../../../hooks/useDashboardData";

export default function Dashboard() {
  const [collapsed, setCollapsed] = useState(false);

  // Use custom hook to manage dashboard data lifecycle
  const { refreshData } = useDashboardData([
    getSummary,
    () => topPractitioner({}),
    () => getCounsellorList("Bearer " + localStorage.getItem("token")),
    getWellness
  ]);

  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          {/* Page Header */}
          <div className="pl-[10px] mb-3">
            <h1 className="text-2xl font-semibold text-[#171717] font-poppins mb-0">
              Dashboard
            </h1>
            <p className="text-[#64748B] text-sm mt-1 mb-0 font-poppins">
              Here’s a quick look at your members, practitioners, appointments and events.
            </p>
          </div>

          {/* Top Section: Overview Stats + Top Practitioners */}
          <div className="flex flex-col xl:flex-row gap-3 items-start xl:items-stretch justify-start relative w-full mb-3">
            {/* Overview Stats Section */}
            <div className="flex-1 w-full">
              <OverviewStatsSection />
            </div>

            {/* Top Practitioners */}
            <div className="flex w-full xl:w-[407px]">
              <TopPractitionersSection />
            </div>
          </div>

          {/* Middle Section: Recent Booked + Risk Status */}
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-3 items-stretch w-full mb-3">
            {/* Recent Booked Table */}
            <div className="bg-white rounded-2xl relative w-full xl:col-span-2 min-w-0">
              <RecentBookedTable />
            </div>

            {/* Risk Distribution Chart */}
            <div className="min-w-0">
              <RiskDistributionChart />
            </div>
          </div>

          {/* Bottom Section: Appointments Trend + Event Participation / Available Practitioners */}
          <div className="grid grid-cols-1 xl:grid-cols-3 gap-3 items-stretch w-full">
            {/* Appointments Trend Chart — stretches to match the right column's height */}
            <div className="xl:col-span-2 min-w-0">
              <AppointmentsTrendChart />
            </div>

            <div className="flex flex-col gap-3 min-w-0">
              <AvailablePractitionersSection />
              {/* Event Participation Table */}
              <div className="bg-white rounded-2xl relative w-full">
                <EventParticipationTable />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}